var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelWhatsappIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M0,11A11,11,0,1,0,11,0,11,11,0,0,0,0,11Z",
    fill: "#25d366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M19.888,10.01A6.875,6.875,0,0,0,14.993,8,6.959,6.959,0,0,0,8.962,18.489L8,21.986l3.671-.962a7.526,7.526,0,0,0,3.322.874A6.923,6.923,0,0,0,19.888,10.01ZM14.993,20.762a5.813,5.813,0,0,1-2.972-.787l-.175-.087L9.661,20.5l.612-2.1L10.1,18.14a5.624,5.624,0,0,1-.874-3.059,5.82,5.82,0,0,1,5.769-5.769A5.973,5.973,0,0,1,19.1,10.972a5.605,5.605,0,0,1,1.661,4.108A5.746,5.746,0,0,1,14.993,20.762Zm3.147-4.371a7.367,7.367,0,0,0-1.224-.524c-.175-.087-.262-.087-.35.087s-.437.524-.524.7c-.087.087-.175.087-.35.087a4.888,4.888,0,0,1-1.4-.874,4.248,4.248,0,0,1-.962-1.224c-.087-.175,0-.262.087-.35l.262-.262c.087-.087.087-.175.175-.262s0-.175,0-.262a9.976,9.976,0,0,0-.524-1.311.326.326,0,0,0-.35-.262h-.35a.565.565,0,0,0-.437.175,1.957,1.957,0,0,0-.612,1.486,3.74,3.74,0,0,0,.7,1.836,7.529,7.529,0,0,0,2.972,2.622,3.486,3.486,0,0,0,2.1.437,1.54,1.54,0,0,0,1.136-.787c.175-.437.175-.787.087-.787A.565.565,0,0,0,18.14,16.391Z",
    transform: "translate(-3.993 -3.993)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelWhatsappIcon);
export default __webpack_public_path__ + "static/media/channel-whatsapp-icon.285d2d70ca2061deaf9565378d4c127b.svg";
export { ForwardRef as ReactComponent };